import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FinancialRoutingModule } from './financial-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from 'src/app/material.module';
import { IonicModule } from '@ionic/angular';
import { FinancialPageComponent } from './components/financial-page/financial-page.component';
import { AdminFinancialComponent } from './components/admin-financial/admin-financial.component';


@NgModule({
  declarations: [FinancialPageComponent, AdminFinancialComponent],
  imports: [
    CommonModule,
    FinancialRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    IonicModule.forRoot(),
  ]
})
export class FinancialModule { }
